:host {
  display: inline-block;
  position: relative;
}

.br-datetime-picker {
  br-card {
    font-size: var(--font-size-scale-base);
  }

  &.datetime,
  &.date {
    width: 304px;
    height: auto;
  }

  &.time {
    width: 144px;
    height: 116px;
  }

  /* HEADER: linha com botões + mês + ano */
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: var(--spacing-scale-base);
  }

  select {
    appearance: none;
    border: none;
    background: transparent;
    padding-right: 20px;
    font-size: var(--font-size-scale-up-01);
    font-weight: var(--font-weight-semi-bold);
    color: var(--blue-warm-vivid-70);
    outline: none;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'><path fill='%231351b4' d='M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L224 285.229l154.706-154.705c9.373-9.373 24.569-9.373 33.941 0l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.373-24.569 9.373-33.942 0z'/></svg>");
    background-repeat: no-repeat;
    background-position: right 0.35rem center;
    background-size: 10px;

    option {
      color: var(--color);
    }

    &:focus {
      outline: none;
    }

    &:hover {
      cursor: pointer;
    }
  }

  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    white-space: nowrap;
    border: 0;
  }

  /* Ajustes visuais para input nativo */
  input[type="number"] {
    width: 70px;
    padding: 4px;
    font-size: var(--font-size-scale-up-01);
    font-weight: var(--font-weight-semi-bold);
    background-color: var(--gray-0);
    color: var(--gray-80);
    text-align: center;
    border-color: var(--border-color-alternative);
    border-radius: var(--surface-rounder-sm);
    border-style: var(--border-style);
    border-width: var(--border-width);

    &:hover {
      background: linear-gradient(rgb(var(--color-rgb), var(--hover)), rgb(var(--color-rgb), var(--hover)));
    }
  }

  .weekdays {
    margin-bottom: var(--spacing-scale-half);
  }

  .weekdays,
  .monthdays {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    text-align: center;
    gap: var(--spacing-scale-half) var(--spacing-scale-half);
  }

  .weekday {
    font-weight: var(--font-weight-medium);
    color: var(--gray-70);
    width: var(--spacing-scale-4x);
  }

  .day {
    padding: var(--spacing-scale-half);
    font-weight: var(--font-weight-semi-bold);
    color: var(--blue-warm-vivid-70);
    border-radius: 50%;
    width: var(--spacing-scale-4x);
    height: var(--spacing-scale-4x);
    line-height: var(--spacing-scale-3x);

    &:hover {
      background: var(--hover-effect);
      cursor: pointer;
    }

    &.selected {
      background: var(--blue-warm-vivid-70);
      color: var(--color-secondary-01);
      font-weight: var(--font-weight-bold);
    }
  }

  .outside-month {
    font-weight: var(--font-weight-regular);
    opacity: 0.6;
  }

  .today {
    background: var(--orange-vivid-5);
    color: var(--red-warm-vivid-50);
  }

  .time-section {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: var(--spacing-scale-base);
  }

  .time-field {
    display: flex;
    flex-direction: column;
    align-items: center;

    label {
      font-size: var(--font-size-scale-down-01);
      color: var(--gray-70);
      margin-bottom: 4px;
    }

    input {
      width: var(--spacing-scale-6x);
      height: var(--spacing-scale-6x);
      padding: 4px;
      font-size: var(--font-size-scale-up-01);
      font-weight: var(--font-weight-semi-bold);
      text-align: center;
      border-color: var(--border-color-alternative);
      border-radius: var(--surface-rounder-sm);
      border-style: var(--border-style);
      border-width: var(--border-width);

      &:hover {
        background: linear-gradient(rgb(var(--color-rgb), var(--hover)), rgb(var(--color-rgb), var(--hover)));
      }
    }
  }

  .time-separator {
    font-size: var(--font-size-scale-up-01);
    font-weight: var(--font-weight-semi-bold);
    color: var(--gray-70);
    margin-bottom: 8px;
  }

  br-input {
    br-icon {
      cursor: pointer;
    }
  }

  .dropdown {
    position: absolute;
    top: 48px;
    left: 0;
    z-index: var(--z-index-layer-1);
    display: none;
  }

  .dropdown.open {
    display: block;
  }
}
